import { useCallback, useState, useEffect } from "react";
import useLocalTable from "./useLocalTable";

const useEntityFormViewTable = (data, getFilters) => {
    const { rows, onFilter } = useLocalTable(data, false);
    const [filterData, setFilterData] = useState([]);
    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        const filters = getFilters(searchString, filterData);
        onFilter(filters);
    }, [searchString, filterData, getFilters, onFilter]);

    const setFilterDataCallback = useCallback((newFilterData) => {
        setFilterData(newFilterData);
    }, []);

    const setSearchStringCallback = useCallback((newSearchString) => {
        setSearchString(newSearchString);
    }, []);

    return {
        rows,
        searchString,
        setSearchString: setSearchStringCallback,
        filterData,
        setFilterData: setFilterDataCallback
    };
};

export default useEntityFormViewTable;